/* RESPONSIBLE TEAM: team-proactive-support */

import Model, { attr } from '@ember-data/model';

export default class SpambotContact extends Model {
  @attr('string') declare emailAddress: string;
}
